import script from "./NewYearAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewYearAlert.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__